import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import Icon from '@components/custom/Icon';

import { useCheckPageAccess } from '@sm/hooks/useCheckPageAccess';
import { useCheckCategoryAccess } from '@sm/hooks/useCheckCategoryAccess';

const MenuItem = ({ item, isLogout, handleLogoutClick }) => {
  const location = useLocation();
  const hasPageAccess = useCheckPageAccess(item?.access);
  const hasCategoryAccess = useCheckCategoryAccess(item?.access);
  
  let permission = false;
  if (isLogout) {
    permission = true;
  } else if (item.permission) {
    permission = hasPageAccess;
  } else {
    permission = hasCategoryAccess;
  }

  if (!permission) return null;

  const extraProps = item?.id === 'folder_code' ? { target: "_blank", rel: "noopener noreferrer" }: {};

  return (
    <li className="nav-item">
      {isLogout ? (
        <>
          <span className='nav-link logout' onClick={ handleLogoutClick }>
            <Icon name='logout' />
            Logout
          </span>
        </>
      ) : (
        <NavLink
          to={ item.url }
          className={ ({ isActive }) =>
            isActive && location?.pathname + location?.search === item.url && location?.state?.report === item?.report
              ? "nav-link active"
              : "nav-link"
          }
          { ...(item.report && { state: { report: item.report } } ) }
          { ...extraProps }
        >
          <span className='icon-wrap'>
            <Icon name={ item.id } />
          </span>
          { item.name }
        </NavLink>
      )}
    </li>
  );
};

export default MenuItem;
